import React from 'react';

import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
} from '@material-ui/core';
import PropTypes from 'prop-types';

import { number } from '~/helpers';

import Card from '../Card';
import SemDados from '../SemDados';
import * as S from './styles';

function CardPercCapTq({ titulo, icone, headers, data, tooltip, style }) {
  const corCelulaPercentual = (percentual) => {
    if (percentual > 100) {
      return 'darkorange';
    }

    if (percentual > 90) {
      return 'green';
    }

    return '#d32f2f';
  };

  return (
    <Card title={titulo} icon={icone} tooltip={tooltip} style={style}>
      {data && data.length > 0 ? (
        <S.Container style={{ '--total-table-rows': data.length + 1 }}>
          <TableContainer>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  {headers.map((header, index) => (
                    <TableCell key={`cell-index-head-${index}`}>
                      {header}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {data.map((row, index) => (
                  <TableRow tabIndex={-1} key={`table-row-body-${index}`}>
                    <TableCell key="table-cell-body-1">
                      {row.nomeabreviadoposto}
                    </TableCell>
                    <TableCell key="table-cell-body-2">
                      {row.nomeabreviadoproduto}
                    </TableCell>
                    <TableCell
                      key="table-cell-body-3"
                      style={{
                        backgroundColor: corCelulaPercentual(row.percentual),
                        color: '#fff',
                        textAlign: 'center',
                        padding: 0,
                      }}
                    >
                      {`${number(row.percentual, 2)}%`}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </S.Container>
      ) : (
        <SemDados />
      )}
    </Card>
  );
}

CardPercCapTq.propTypes = {
  titulo: PropTypes.string.isRequired,
  icone: PropTypes.element.isRequired,
  headers: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      nomeabreviadoposto: PropTypes.string.isRequired,
      nomeabreviadoproduto: PropTypes.string.isRequired,
      percentual: PropTypes.number.isRequired,
    })
  ).isRequired,
  tooltip: PropTypes.string.isRequired,
  style: PropTypes.objectOf(PropTypes.any),
};

CardPercCapTq.defaultProps = {
  style: {},
};

export default CardPercCapTq;
